import { useRoute } from 'vue-router';
import { useStore } from './store';

// Account payloads are authoritative. Never reuse another company's grant or
// the installation-wide HTML flag while the current account is loading.
export function useTeletelFeatures() {
  const route = useRoute();
  const store = useStore();

  const isTeletelFeatureEnabled = feature => {
    const accountId = Number(route.params.accountId);
    if (!accountId) return false;
    const account = store.getters['accounts/getAccount']?.(accountId);
    return account?.teletel_features?.[feature] === true;
  };

  // True once the account payload carries a Teletel decision for the feature.
  // Callers use it to hand a legacy licensed flag over to the Teletel grant
  // without guessing on a build that has no Teletel grants at all.
  const isTeletelFeatureManaged = feature => {
    const accountId = Number(route.params.accountId);
    if (!accountId) return false;
    const account = store.getters['accounts/getAccount']?.(accountId);
    return account?.teletel_features?.[feature] !== undefined;
  };

  // The single rule for a feature that has both a Teletel grant and a legacy
  // licensed flag: the grant decides once the company payload carries one, and
  // the licensed flag stays in charge on a build that publishes no grants.
  // Callers pass the legacy value rather than re-deriving the rule, so a
  // surface cannot drift from the gate its API enforces.
  const isTeletelFeatureEnabledOrLegacy = (feature, legacyEnabled) =>
    isTeletelFeatureManaged(feature)
      ? isTeletelFeatureEnabled(feature)
      : Boolean(legacyEnabled);

  return {
    isTeletelFeatureEnabled,
    isTeletelFeatureManaged,
    isTeletelFeatureEnabledOrLegacy,
  };
}
